export const HOME_CURRENCY = 'homeCurrency';
export const MARKET_DATA_SOURCE = 'marketDataSource';

const orgSettings = {
  HOME_CURRENCY,
  MARKET_DATA_SOURCE,
};

export default orgSettings;
